"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

import { handleSignupModalOpened } from "@/src/store/signup";

import { sendActivationLink } from "services/auth";

import GreenCheck from "assets/svg/green-check-circle.svg";

import Button from "components/common/button";

import styles from "./styles.module.css";

const ModalSignupEmailResult = ({ data }) => {
  const [isEmailButtonPassive, setIsEmailButtonPassive] = useState(false);

  const emailReduxState = useSelector((state) => state.signup.email);
  const passwordReduxState = useSelector((state) => state.signup.password);
  const router = useRouter();
  const dispatch = useDispatch();

  const handleSendEmail = async () => {
    if (isEmailButtonPassive) return null;
    setIsEmailButtonPassive(true);
    if (emailReduxState && passwordReduxState) {
      // mail gönderme aksiyonu
      await sendActivationLink({ email: emailReduxState, password: passwordReduxState });
    }
  };

  const handleSuccessModal = () => {
    dispatch(handleSignupModalOpened());
    router.push("/giris");
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.iconWrap}>
        <GreenCheck />
      </div>
      <h2 className={styles.title}>Son Bir Adım Kaldı!</h2>
      <p className={styles.content}>
        Emlakjet’te hayalindeki evi bulacaksın. Ama lütfen önce e-posta adresine gönderdiğimiz bağlantıya tıkla ve
        üyelik işlemini tamamla.
      </p>
      {isEmailButtonPassive ? (
        <div className={styles.buttonWrapper}>
          <Button size={"M"} onClick={handleSuccessModal}>
            Tamam
          </Button>
        </div>
      ) : (
        <p className={styles.content}>
          Mail gelmedi mi?
          <span className={styles.textLink} onClick={handleSendEmail}>
            Tekrar Gönder
          </span>
        </p>
      )}
    </div>
  );
};

ModalSignupEmailResult.propTypes = {
  data: PropTypes.object,
};

export default ModalSignupEmailResult;
